import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import OutsideClickHandler from 'react-outside-click-handler'
import { useKeyPress } from '../lib/lib'
import Typography from './typography'
import Divider from './divider'
const { Heading } = Typography

interface IDrawerProps extends React.HTMLProps<HTMLDivElement> {
  children?: React.ReactNode
  position?: 'right' | 'left'
  title?: string
  width?: number
  isVisible?: boolean
  onClose?: () => void
}

const Drawer: React.FC<IDrawerProps & any> = ({
  children,
  position,
  title,
  width = 300,
  onClose,
  isVisible,
  ...rest
}) => {
  const escapePressed = useKeyPress('Escape')

  React.useEffect(() => {
    if (onClose && escapePressed) {
      onClose()
    }
  }, [escapePressed])

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          transition={{ ease: 'linear' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className='drawer-wrapper'
          data-position={position}
          onKeyDown={(e) => {
            if (e.keyCode === 27 && onClose) {
              onClose()
            }
          }}
        >
          <OutsideClickHandler
            onOutsideClick={() => {
              if (onClose) {
                onClose()
              }
            }}
          >
            <motion.div
              transition={{ ease: 'easeOut' }}
              initial={{ x: (position === 'left' ? -1 : 1) * width }}
              exit={{ x: (position === 'left' ? -1 : 1) * width }}
              animate={{ x: 0 }}
              className='drawer-window'
              style={{ maxWidth: width }}
              {...rest}
            >
              {title && (
                <div>
                  <div className='drawer-header'>
                    <Heading level={3}>{title}</Heading>
                  </div>
                  <Divider />
                </div>
              )}
              <div className='drawer-content'>{children}</div>
            </motion.div>
          </OutsideClickHandler>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Drawer
